import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'mango-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss'],
})
export class ListViewComponent implements OnInit {
  @Input() selected!: string;

  @Output() onSelected = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  btnSelected(type: string) {
    this.onSelected.emit(type);
    this.selected = type;
  }
}
